<template>
  <!-- Всего 4 типа плашек:
    info - серая
    warning - желтая
    error - красная
    success - зеленая
 -->
  <div :class="['alert', `alert--${type}`]">
    <Icon :iconName="iconName" :iconColor="iconColor || calcIconColor" />
    <div class="alert__body">
      <p v-html="text"></p>
      <a v-if="url" :href="url.value" target="_blank">{{
        url.lbl ? url.lbl : ''
      }}</a>
      <p v-if="buttonLabel" @click="$emit('buttonClick')" class="link">
        {{ buttonLabel }}
      </p>
    </div>
  </div>
</template>
<script>
import Icon from 'Elements/Icon/Icon';
export default {
  props: {
    text: {
      type: String
    },
    type: {
      type: String,
      default: 'info'
    },
    url: {
      type: [String, Object],
      default: ''
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      if (this.type == 'warning') {
        return 'Warning';
      } else if (this.type == 'error') {
        return 'error';
      } else if (this.type == 'success') {
        return 'success';
      } else {
        return 'CircleWarning';
      }
    },
    calcIconColor() {
      if (this.type == 'warning') {
        return '#FFB70F';
      } else if (this.type == 'error') {
        return '#FC311E';
      } else if (this.type == 'success') {
        return '#00B336';
      } else {
        return '#788694';
      }
    }
  },
  components: { Icon }
};
</script>
<style lang="scss" scoped>
.alert {
  border-radius: 4px;
  width: 100%;
  display: flex;
  gap: 9px;
  padding: 12px 16px;

  &__body {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
  }

  p,
  a {
    font-weight: 400;
    font-size: 16px;
    text-align: left;
    line-height: 24px;
    text-decoration: unset;
    word-wrap: break-word;
  }

  a,
  .link {
    color: $blue64;
    cursor: pointer;
  }

  &--info {
    background: $grey8;
    color: $grey64;
  }

  &:not(.alert--info) {
    color: $grey80;
  }

  &--warning {
    background: $yellow16;
  }

  &--error {
    background: $red16;
  }

  &--success {
    background: $green16;
  }
}
</style>
